/**
 * Load an external script once, returning a promise that resolves when it's
 * ready. Repeated calls for the same src reuse the in-flight/loaded script.
 */
const cache = new Map<string, Promise<void>>();

export function loadScript(src: string): Promise<void> {
  const existing = cache.get(src);
  if (existing) {
    return existing;
  }

  const promise = new Promise<void>((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.defer = true;
    script.onload = () => resolve();
    script.onerror = () => {
      cache.delete(src); // Allow a retry on failure.
      reject(new Error(`Failed to load script: ${src}`));
    };
    document.head.appendChild(script);
  });

  cache.set(src, promise);
  return promise;
}
